/**
 * Notification Service — frontend API client
 *
 * ВАЖНО: запросы идут на основной backend `/api/notifications/*`, не на `/api/notifications/v1/*`.
 * Nginx шлёт `/api/notifications/v1/` сразу в notifications-backend без JWT и без X-User-Id —
 * инбокс отдаёт 401. Legacy-роутер backend после authenticate проксирует на модуль с заголовками.
 */
import axios from '../utils/axios';

const LEGACY = '/api/notifications';

/** 5xx / сеть: безопасные значения для чтения, чтобы не засорять UI и не ломать поллинг */
function isNotificationsReadDegradableError(err) {
  const s = err?.response?.status;
  if (s >= 500) return true;
  if (!err?.response && (err?.code === 'ERR_NETWORK' || err?.message === 'Network Error')) return true;
  return false;
}

const notificationService = {
  async getNotifications(params = {}) {
    try {
      const response = await axios.get(LEGACY, { params });
      return response.data;
    } catch (err) {
      if (isNotificationsReadDegradableError(err)) {
        return { items: [], count: 0 };
      }
      throw err;
    }
  },

  async getUnreadCount() {
    try {
      const response = await axios.get(`${LEGACY}/unread-count`);
      return response.data;
    } catch (err) {
      if (isNotificationsReadDegradableError(err)) {
        return { count: 0 };
      }
      throw err;
    }
  },

  async markAsRead(notificationId) {
    const response = await axios.put(`${LEGACY}/${notificationId}/read`);
    return response.data;
  },

  async markAllAsRead() {
    const response = await axios.put(`${LEGACY}/mark-all-read`);
    return response.data;
  },

  async deleteNotification(notificationId) {
    const response = await axios.delete(`${LEGACY}/${notificationId}`);
    return response.data;
  },

  async deleteAllRead() {
    const response = await axios.delete(LEGACY);
    return response.data;
  },

  async getPreferences() {
    const response = await axios.get(`${LEGACY}/preferences`);
    return response.data;
  },

  async updatePreferences(preferences) {
    const response = await axios.put(`${LEGACY}/preferences`, { preferences });
    return response.data;
  },

  async getCompanyPreferences() {
    const response = await axios.get(`${LEGACY}/preferences/company`);
    return response.data;
  },

  async updateCompanyPreferences(preferences) {
    const response = await axios.put(`${LEGACY}/preferences/company`, { preferences });
    return response.data;
  },
};

export default notificationService;
